// slider
var rankingSliders = new Array();
document.addEventListener('DOMContentLoaded', function () {
  const mvOptions = {
    arrows: true,
    cover: true,
    perMove: 1,
    gap: 0,
    updateOnMove: true,
    padding: 0,
    type: "loop",
    focus: "center",
    classes: {
      pagination: "splide__pagination your-class-pagination",
      page: "splide__pagination__page your-class-page",
    },
  };

  const rankingOptions = {
    arrows: true,
    cover: true,
    perMove: 1,
    perPage: 4,
    gap: "25px",
    start: number = 0,
    updateOnMove: true,
    padding: 0,
    type: "loop",
    classes: {
      page: "splide__pagination__page your-class-page",
    },
    breakpoints: {
      767: {
        perPage: 1.5,
      }
    },
  };

  const reviewOptions = {
    arrows: true,
    cover: true,
    perMove: 2,
    perPage: 2,
    gap: "60px",
    updateOnMove: true,
    padding: 0,
    type: "loop",
    // focus: "center",
    classes: {
      page: "splide__pagination__page your-class-page",
    },
    breakpoints: {
      767: {
        perMove: 1,
        perPage: 1,
        gap: "30px",
        focus: "center",
      }
    },
  };

  if (document.querySelector('.mv_slide')) {
    const splidemv = new Splide(".mv_slide", mvOptions).mount();
  }

  // if (document.querySelector('.l_ranking_slide')) {
  //   const splideranking = new Splide(".l_ranking_slide", rankingOptions).mount();
  // }

  for(let i=1;i<=8;i++){
    if (document.querySelector('#ranking_slide'+i)) {
      const splide = new Splide("#ranking_slide"+i, rankingOptions).mount();
      rankingSliders['#ranking_slide'+i] = splide;
    }
  }

  if (document.querySelector('.review_slide')) {
    const spliderreview = new Splide(".review_slide", reviewOptions).mount();
  }
});


// new item
function toggleNewItemBlock(blockNumber, clickedButton) {
  // すべてのブロックから visible クラスを削除する
  const allNewItemBlocks = document.querySelectorAll('.l_new_item_block');
  allNewItemBlocks.forEach(block => block.classList.remove('visible'));
  // 対応するブロックに visible クラスを付与する
  const targetNewItemBlock = document.getElementById(`new_block${blockNumber}`);
  if (targetNewItemBlock) {
    targetNewItemBlock.classList.add('visible');
  }
  // すべてのボタンから `active` クラスを削除し、クリックされたボタンに `active` クラスを付与する
  const allNewItemButtons = document.querySelectorAll('.l_new_item_btn');
  allNewItemButtons.forEach(button => button.classList.remove('active'));
  clickedButton.classList.add('active');
}
// ページ読み込み時に new_block1 の表示を設定し、他のブロックの visible クラスを削除する
document.addEventListener("DOMContentLoaded", function() {
  const defaultBlock = document.getElementById('new_block1');
  if (defaultBlock) {
    defaultBlock.classList.add('visible');
  }
  const otherBlocks = document.querySelectorAll('.l_new_item_block:not(#new_block1)');
  otherBlocks.forEach(block => block.classList.remove('visible'));
  const firstBrandsBtn = document.querySelector('.l_new_item_btn');
  if (firstBrandsBtn) {
    firstBrandsBtn.classList.add('active');
  }
});


// ranking
function toggleRankingBlock(blockNumber, clickedButton) {
  // すべてのスライドから active-arrow クラスを削除する
  const allRankingSlides = document.querySelectorAll('.l_ranking_slide');
  allRankingSlides.forEach(block => block.classList.remove('active-arrow'));
  // 対応するスライドに active-arrow クラスを付与する
  const targetRankingSlide = document.getElementById(`ranking_slide${blockNumber}`);
  if (targetRankingSlide) {
    targetRankingSlide.classList.add('active-arrow');
  }
  // すべてのブロックから visible クラスを削除する
  const allRankingBlocks = document.querySelectorAll('.l_ranking_block');
  allRankingBlocks.forEach(block => block.classList.remove('visible'));
  // 対応するブロックに visible クラスを付与する
  const targetRankingBlock = document.getElementById(`ranking_block${blockNumber}`);
  if (targetRankingBlock) {
    targetRankingBlock.classList.add('visible');
  }
  // すべてのボタンから `active` クラスを削除し、クリックされたボタンに `active` クラスを付与する
  const allRankingButtons = document.querySelectorAll('.l_ranking_btn');
  allRankingButtons.forEach(button => button.classList.remove('active'));
  clickedButton.classList.add('active');

  if(rankingSliders.hasOwnProperty("#ranking_slide"+blockNumber)){
    rankingSliders["#ranking_slide"+blockNumber].refresh();
  }
}
// ページ読み込み時に ranking_slide1 の表示を設定し、他のブロックの active-arrow クラスを削除する
document.addEventListener("DOMContentLoaded", function() {
  const defaultSlide = document.getElementById('ranking_slide1');
  if (defaultSlide) {
    defaultSlide.classList.add('active-arrow');
  }
  const otherSlides = document.querySelectorAll('.l_ranking_slide:not(#ranking_slide1)');
  otherSlides.forEach(block => block.classList.remove('active-arrow'));
  const firstSlidesBtn = document.querySelector('.l_ranking_btn');
  if (firstSlidesBtn) {
    firstSlidesBtn.classList.add('active');
  }
});
// ページ読み込み時に ranking_block1 の表示を設定し、他のブロックの visible クラスを削除する
document.addEventListener("DOMContentLoaded", function() {
  const defaultBlock = document.getElementById('ranking_block1');
  if (defaultBlock) {
    defaultBlock.classList.add('visible');
  }
  const otherBlocks = document.querySelectorAll('.l_ranking_block:not(#ranking_block1)');
  otherBlocks.forEach(block => block.classList.remove('visible'));
  const firstBrandsBtn = document.querySelector('.l_ranking_btn');
  if (firstBrandsBtn) {
    firstBrandsBtn.classList.add('active');
  }
});

// bramds
function toggleBrandsBlock(blockNumber, clickedButton) {
  // すべてのブロックから visible クラスを削除する
  const allBrandsBlocks = document.querySelectorAll('.l_brands_block');
  allBrandsBlocks.forEach(block => block.classList.remove('visible'));
  // 対応するブロックに visible クラスを付与する
  const targetBrandsBlock = document.getElementById(`brands_block${blockNumber}`);
  if (targetBrandsBlock) {
    targetBrandsBlock.classList.add('visible');
  }
  // すべてのボタンから `active` クラスを削除し、クリックされたボタンに `active` クラスを付与する
  const allBrandsButtons = document.querySelectorAll('.l_brands_btn');
  allBrandsButtons.forEach(button => button.classList.remove('active'));
  clickedButton.classList.add('active');
}
// ページ読み込み時に brands_block1 の表示を設定し、他のブロックの visible クラスを削除する
document.addEventListener("DOMContentLoaded", function() {
  const defaultBlock = document.getElementById('brands_block1');
  if (defaultBlock) {
    defaultBlock.classList.add('visible');
  }
  const otherBlocks = document.querySelectorAll('.l_brands_block:not(#brands_block1)');
  otherBlocks.forEach(block => block.classList.remove('visible'));
  const firstBrandsBtn = document.querySelector('.l_brands_btn');
  if (firstBrandsBtn) {
    firstBrandsBtn.classList.add('active');
  }
});




var parallaxTargets = null;
window.addEventListener("load",function(){
	parallaxTargets = new Array();
	let parallaxWrappers = document.querySelectorAll("*[data-parallax]");
	for(let i=0;i<parallaxWrappers.length;i++){
		let img = parallaxWrappers[i].querySelector("img");
		if(!img){continue;}
		parallaxTargets.push({
			wrapper : parallaxWrappers[i],
			image : img,
		});
	}
	parallaxHandler();
});

window.addEventListener("scroll",parallaxHandler);
function parallaxHandler(){
	if(!parallaxTargets){return;}
	let scrollTop = window.scrollY ? window.scrollY :
		window.pageYOffset ? window.pageYOffset :
		document.compatMode === 'CSS1Compat' ? document.documentElement.scrollTop :
		document.body.scrollTop;

	for(let i=0;i<parallaxTargets.length;i++){
		let wrapperRect = parallaxTargets[i].wrapper.getBoundingClientRect();
		let t = window.innerHeight - wrapperRect.top;
		let r = window.innerHeight + wrapperRect.height;
		t = (t*60) / r - 60;
		parallaxTargets[i].image.style.transform = "translate(0,"+t+"%)";
	}
}

// アコーディオン
function homeAccordion() {
  const triggers = document.querySelectorAll('.p-home__accordion__trigger')

  triggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      trigger.classList.toggle('clicked')
      if (trigger.classList.contains("clicked")) {
        console.log('click true')
        trigger.closest(".l_faq_item").querySelector(".accordionContent").style.padding = "20px 100px";
        //trigger.closest(".l_faq_item").querySelector(".accordionContent").style.display = "block";
        trigger.closest(".l_faq_item").querySelector(".accordionContent").setAttribute("data-before-content", "A.");
      } else {
        console.log('click')
        trigger.closest(".l_faq_item").querySelector(".accordionContent").style.padding = "0 100px";
        //trigger.closest(".l_faq_item").querySelector(".accordionContent").style.display = "none";
        trigger.closest(".l_faq_item").querySelector(".accordionContent").setAttribute("data-before-content", "");
      }
    })
  })
}
// homeAccordion()

document.addEventListener("DOMContentLoaded", function() {
  const toTopButton = document.querySelector(".js-to-top");
  toTopButton.style.display = "none";

  window.addEventListener("scroll", function() {
      if (window.scrollY > 1000) {
          toTopButton.style.display = "block";
          toTopButton.style.opacity = "1";
      } else {
          toTopButton.style.opacity = "0";
          setTimeout(function() {
              toTopButton.style.display = "none";
          }, 400);
      }
  });

  toTopButton.addEventListener("click", function() {
      window.scrollTo({
          top: 0,
          behavior: "smooth"
      });
      return false;
  });
});

var accordionBreakPoint = 989;
document.head.innerHTML += "<style>.aci01{display:none} @media (min-width:" + (accordionBreakPoint + 1) + "px){.aci01{display:block!important}}</style>";

window.addEventListener("DOMContentLoaded", function() {
  var ac01Elements = document.querySelectorAll('.ac01');

  ac01Elements.forEach(function(element) {
      var aci01Element = element.parentNode.querySelector('.aci01');
      // 初期状態でaci01要素にdisplay: none;を適用
      aci01Element.style.display = 'none';

      element.addEventListener('click', function(e) {
          if (window.innerWidth <= accordionBreakPoint) {
              e.preventDefault();
              e.stopPropagation();
              
              // aci01要素のdisplayプロパティをトグルする
              if (aci01Element.style.display === 'none') {
                  aci01Element.style.display = 'block';
                  this.classList.add('open'); // ac01要素にopenクラスを追加
              } else {
                  aci01Element.style.display = 'none';
                  this.classList.remove('open'); // ac01要素からopenクラスを削除
              }
          }
      });
  });
});




function faqAccordion() {
  const triggerButton = document.querySelectorAll('.p-home__accordion__trigger');

  triggerButton.forEach((button) => {
    button.addEventListener('click', (e) => {
      const body       = e.currentTarget.nextElementSibling,
            text       = body.children[0],
            textHeight = body.getBoundingClientRect().height,
            menu       = e.currentTarget;

      menu.classList.toggle('is-open');
      /*
      let height = 0;
      for(let i=0;i<body.children.length;i++){
        height += body.children[i].offsetHeight;
      }

      if (menu.classList.contains('is-open')) {
        body.style.height = height + 'px';
      } else {
        body.style.height = 0;
      }
      */
    })
  })
}
faqAccordion()

function categoryAccordion() {
  const triggerButton = document.querySelectorAll('.l_category_title')

  triggerButton.forEach((button) => {
    if (window.matchMedia("(max-width: 767px)").matches) {
      button.addEventListener('click', (e) => {
        const body       = e.currentTarget.nextElementSibling,
              text       = body.children[0],
              textHeight = body.getBoundingClientRect().height,
              menu       = e.currentTarget

        menu.classList.toggle('is-open')
        let height = 0;
        for(let i=0;i<body.children.length;i++){
          height += body.children[i].offsetHeight;
        }

        if (menu.classList.contains('is-open')) {
          // 一時的に要素を可視状態にして高さを取得
          body.style.visibility = 'hidden';
          body.style.display = 'block'; // 必要に応じて要素のディスプレイ属性を変更してください
          const textHeight = body.scrollHeight - 100; // scrollHeightを使用してコンテンツの高さを取得
          body.style.display = ''; // ディスプレイ属性を元に戻す
          body.style.visibility = ''; // 可視性を元に戻す
          body.style.height = height + 'px'
        } else {
          body.style.height = 0
        }
      })
    } else {}
  })
}
categoryAccordion()


var parallaxTargets = null;
window.addEventListener("load",()=>{
	parallaxTargets = document.querySelectorAll("img[data-parallax]");
	if(parallaxTargets){
		parallaxTargets.forEach(p=>{p.style.objectFit="cover";});
		window.addEventListener("resize",parallaxHandler,{passive:true});
		window.addEventListener("scroll",parallaxHandler,{passive:true});
		parallaxHandler();
	}
});
function parallaxHandler(){
  if(!parallaxTargets){return;}
	parallaxTargets.forEach(p=>{
		let r = p.getBoundingClientRect();
		p.style.objectPosition = "center "+((r.top+r.height) / (window.innerHeight+r.height) * 100)+"%";
	});
}




document.addEventListener("DOMContentLoaded", function() {
  var searchModalMask01 = document.querySelector('.search_modal_mask01');
  var searchModal01 = document.querySelector('.search_modal01');
  var searchBox01 = document.querySelector('.search_box01');
  var searchModalClose01 = document.querySelector('.search_modal_close01');
  var allOn01 = document.querySelector('.allOn');
  var allOff01 = document.querySelector('.allOff');

  if(searchBox01){
    searchBox01.addEventListener('click', function() {
      searchModalMask01.style.display = 'block';
      searchModal01.style.display = 'block';
      document.body.classList.add('noscroll');
    });
  }

  if(searchModalClose01){
    searchModalClose01.addEventListener('click', function() {
      searchModalMask01.style.display = 'none';
      searchModal01.style.display = 'none';
      document.body.classList.remove('noscroll');
    });
  }

  if(searchModalMask01){
    searchModalMask01.addEventListener('click', function() {
      searchModal01.style.display = 'none';
      document.body.classList.remove('noscroll');
      searchModalMask01.style.display = 'none';
    });
  }

  if(allOff01){
    allOn01.addEventListener('change', function() {
      var checkboxes01 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes01.forEach(function(checkbox) {
        if (!checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
    allOff01.addEventListener('change', function() {
      var checkboxes01 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes01.forEach(function(checkbox) {
        if (checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var searchModalMask02 = document.querySelector('.search_modal_mask02');
  var searchModal02 = document.querySelector('.search_modal02');
  var searchBox02 = document.querySelector('.search_box02');
  var searchModalClose02 = document.querySelector('.search_modal_close02');
  var allOn02 = document.querySelector('.allOn');
  var allOff02 = document.querySelector('.allOff');

  if(searchBox02){
    searchBox02.addEventListener('click', function() {
      searchModalMask02.style.display = 'block';
      searchModal02.style.display = 'block';
      document.body.classList.add('noscroll');
    });
  }

  if(searchModalClose02){
    searchModalClose02.addEventListener('click', function() {
      searchModalMask02.style.display = 'none';
      searchModal02.style.display = 'none';
      document.body.classList.remove('noscroll');
    });
  }

  if(searchModalMask02){
    searchModalMask02.addEventListener('click', function() {
      searchModal02.style.display = 'none';
      document.body.classList.remove('noscroll');
      searchModalMask02.style.display = 'none';
    });
  }

  if(allOn02){
    allOn02.addEventListener('change', function() {
      var checkboxes02 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes02.forEach(function(checkbox) {
        if (!checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
    allOff02.addEventListener('change', function() {
      var checkboxes02 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes02.forEach(function(checkbox) {
        if (checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var searchModalMask03 = document.querySelector('.search_modal_mask03');
  var searchModal03 = document.querySelector('.search_modal03');
  var searchBox03 = document.querySelector('.search_box03');
  var searchModalClose03 = document.querySelector('.search_modal_close03');
  var allOn03 = document.querySelector('.allOn');
  var allOff03 = document.querySelector('.allOff');

  if(searchModalMask03){
    searchBox03.addEventListener('click', function() {
      searchModalMask03.style.display = 'block';
      searchModal03.style.display = 'block';
      document.body.classList.add('noscroll');
    });
  }

  if(searchModalClose03){
    searchModalClose03.addEventListener('click', function() {
      searchModalMask03.style.display = 'none';
      searchModal03.style.display = 'none';
      document.body.classList.remove('noscroll');
    });
  }

  if(searchModalMask03){
    searchModalMask03.addEventListener('click', function() {
      searchModal03.style.display = 'none';
      document.body.classList.remove('noscroll');
      searchModalMask03.style.display = 'none';
    });
  }

  if(allOn03){
    allOn03.addEventListener('change', function() {
      var checkboxes03 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes03.forEach(function(checkbox) {
        if (!checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
    allOff03.addEventListener('change', function() {
      var checkboxes03 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes03.forEach(function(checkbox) {
        if (checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  var searchModalMask04 = document.querySelector('.search_modal_mask04');
  var searchModal04 = document.querySelector('.search_modal04');
  var searchBox04 = document.querySelector('.search_box04');
  var searchModalClose04 = document.querySelector('.search_modal_close04');
  var allOn04 = document.querySelector('.allOn');
  var allOff04 = document.querySelector('.allOff');

  if(searchModalMask04){
    searchBox04.addEventListener('click', function() {
      searchModalMask04.style.display = 'block';
      searchModal04.style.display = 'block';
      document.body.classList.add('noscroll');
    });
  }

  if(searchModalClose04){
    searchModalClose04.addEventListener('click', function() {
      searchModalMask04.style.display = 'none';
      searchModal04.style.display = 'none';
      document.body.classList.remove('noscroll');
    });
  }

  if(searchModalMask04){
    searchModalMask04.addEventListener('click', function() {
      searchModal04.style.display = 'none';
      document.body.classList.remove('noscroll');
      searchModalMask04.style.display = 'none';
    });
  }

  if(allOn04){
    allOn04.addEventListener('change', function() {
      var checkboxes04 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes04.forEach(function(checkbox) {
        if (!checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
    allOff04.addEventListener('change', function() {
      var checkboxes04 = document.querySelectorAll('.search_modal_category input[type=checkbox]');
      checkboxes04.forEach(function(checkbox) {
        if (checkbox.checked) {
          checkbox.parentNode.click();
        }
      });
    });
  }
});
